/**
 * @fileOverview This file contains the implementation of the TutorialSearch component for the Tutorials catalog
 * @version 1.0.0
 * @since 1.0.0
 * @author Miguel Ángel Bermea Rodríguez
 */

import { TextField } from "@mui/material";

const TutorialSearch = ({}) => {
  return (
    <TextField
      label="Ingresa el nombre de un modulo para buscar su tutorial"
      variant="filled"
      fullWidth
    />
  );
};

export default TutorialSearch;
